import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ChatBotRoutes } from './chat-bot.routing';
import { ChatBotService } from './services/chat-bot.service';
import { SuporteLocalService } from './services/suporte-local.service';
import { ChatBotComponent } from './components/chat-bot/chat-bot.component';
import { SuporteLocalListComponent } from './components/suporte-local-list/suporte-local-list.component';
import { SharedModule } from 'src/app/shared/shared.module';
import { SuporteLocalEditComponent } from './components/suporte-local-edit/suporte-local-edit.component';
import { SuporteUsuarioListComponent } from './components/suporte-usuario-list/suporte-usuario-list.component';
import { SuporteUsuarioViewComponent } from './components/suporte-usuario-view/suporte-usuario-view.component';
import { SuporteGeralListComponent } from './components/suporte-geral-list/suporte-geral-list.component';
import { SuporteGeralService } from './services/suporte-geral.service';
import { SuporteGeralEditComponent } from './components/suporte-geral-edit/suporte-geral-edit.component';

@NgModule({
  imports: [
    CommonModule,
    ChatBotRoutes,
    SharedModule
  ],
  exports: [
  ],
  declarations: [
    SuporteLocalListComponent,
    SuporteLocalEditComponent,
    SuporteGeralListComponent,
    SuporteGeralEditComponent,
    SuporteUsuarioListComponent,
    SuporteUsuarioViewComponent
  ],
  providers: [
    ChatBotService,
    SuporteLocalService,
    SuporteGeralService
  ],
})
export class ChatBotModule { }
